const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4000/api/v2';

function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64     = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw     = atob(b64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function registerPush(accessToken: string): Promise<void> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  // Registrar el service worker
  const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  await navigator.serviceWorker.ready;

  // Pedir permiso de notificaciones
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return;

  // Obtener la VAPID public key del backend
  const res = await fetch(`${API_URL}/chat/push/vapid-key`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) return;
  const { data } = await res.json();
  if (!data?.publicKey) return;

  // Suscribirse al servidor de push del browser
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly:      true,
    applicationServerKey: urlBase64ToUint8Array(data.publicKey).buffer as ArrayBuffer,
  });

  // Enviar la suscripción al backend para guardarla
  const sub = subscription.toJSON() as { endpoint: string; keys: { p256dh: string; auth: string } };
  await fetch(`${API_URL}/chat/push/subscribe`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
    body:    JSON.stringify(sub),
  });
}

export async function unregisterPush(accessToken: string): Promise<void> {
  if (!('serviceWorker' in navigator)) return;

  const reg = await navigator.serviceWorker.getRegistration('/sw.js');
  if (!reg) return;

  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;

  const endpoint = sub.endpoint;
  await sub.unsubscribe();

  await fetch(`${API_URL}/chat/push/subscribe`, {
    method:  'DELETE',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
    body:    JSON.stringify({ endpoint }),
  });
}
